import {
  ConsentStatus,
  DataChannelAppStateProperty,
  DataChannelUpdateStatus,
  getNewestDataChannelState,
} from '../../video-sdk';

export function resolveCorrectConsentState({
  receivedState,
  userState,
}: {
  receivedState: DataChannelAppStateProperty<ConsentStatus>;
  userState: DataChannelAppStateProperty<ConsentStatus>;
}): [DataChannelAppStateProperty<ConsentStatus>, DataChannelUpdateStatus] {
  const [newestState, comparisonResult] = getNewestDataChannelState({
    receivedState,
    userState,
  });
  const olderState = comparisonResult === DataChannelUpdateStatus.NO_UPDATE_NEEDED ? receivedState : userState;

  /** We have some additional guards for consent status updates,
   * so that certain values cannot be overwritten
   */
  const consentStatesHaveDifferentValues = olderState.value !== newestState.value;

  /** A soft no should override everything except for an opt in or deciding state,
   * regardless of which is newer.
   */
  if (
    consentStatesHaveDifferentValues &&
    olderState.value === ConsentStatus.SOFT_NO &&
    !(newestState.value === ConsentStatus.OPTED_IN || newestState.value === ConsentStatus.DECIDING)
  ) {
    return [
      { value: olderState.value, lastUpdated: Date.now() },
      DataChannelUpdateStatus.VALUE_AND_LAST_UPDATED_CHANGED,
    ];
  }

  /** An opt in should override everything except for a soft no,
   * regardless of which is newer.
   */
  if (
    consentStatesHaveDifferentValues &&
    olderState.value === ConsentStatus.OPTED_IN &&
    newestState.value !== ConsentStatus.SOFT_NO
  ) {
    return [
      { value: olderState.value, lastUpdated: Date.now() },
      DataChannelUpdateStatus.VALUE_AND_LAST_UPDATED_CHANGED,
    ];
  }

  return [newestState, comparisonResult];
}
